import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
    constructor(private http: HttpClient) { }

 getDistinctTransformerId() {
    return this.http.get('getDistinctTransformerId');
 }

 getDistinctSite() {
   return this.http.get('getDistinctSite');
 }
 getParametersByTransformerId(transformerId: string): Observable<any> {
  return this.http.get(`getParameters/${encodeURIComponent(transformerId)}`);
}
 getAlertReportData(payload: any) {
   let url= '';
   console.log('PAyload:', payload);
   return this.http.post('getAlertsReport', payload);
 }
 getObjectReport(payload: any){
  console.log('payload:', payload);
  return this.http.post('objectAndIntrusionDetectionReport',payload)
 }
 getAlertsData(roleid,userid) {
  let url= '';
  return this.http.get(`getAlertsData?roleid=${roleid}&userid=${userid}`);
}

 getReportData(payload:any) {
    let url= '';
    // console.log('FILTERS:', filter);
    // if(filter.length > 0) {
    //     url = `getReport1?` + filter;
    // }
   //  else if(filter.transformerId && filter.date) {
   //      url = `getReport1?transformerId=${filter.transformerId}` + '&' + `date=${filter.date}`
   //      console.log('URL:', url);
   //  }
    // else {
    //     url = `getReport1`;
    // }
    console.log('PAyload:', payload);
   return this.http.post('getReport1', payload);
}
getTapPosition(payload){
  return this.http.post('getTapPosition', payload);
}
getDailyConsumptionReport(deviceid){
  return this.http.get(`getDailyConsumptionReport?deviceid=${deviceid}`,{responseType:'blob'});
}
uploadFolder(files: File[]): Observable<any> {
  const batchSize = 300; // Set the batch size to 300
  const fileBatches = [];

  // Split the files into batches
  for (let i = 0; i < files.length; i += batchSize) {
    const batch = files.slice(i, i + batchSize);
    fileBatches.push(batch);
  }

  // Use from and concatMap to process batches sequentially
  return from(fileBatches).pipe(
    concatMap(batch => {
      const formData = new FormData();
      batch.forEach(file => {
        formData.append('files', file, (file as any).webkitRelativePath); // Maintain folder structure
      });
      // Send each batch to the API and return the response
      return this.http.post('uploadlogfolder', formData);
    })
  );
}
getUploadData(){
  return this.http.get(`saveFileData`);
}
//  getReportData(filter:any) {
//      let url= '';
//      console.log('FILTERS:', filter);
//      if(filter.length > 0) {
//          url = `getReport1?` + filter;
//      }
//     //  else if(filter.transformerId && filter.date) {
//     //      url = `getReport1?transformerId=${filter.transformerId}` + '&' + `date=${filter.date}`
//     //      console.log('URL:', url);
//     //  }
//      else {
//          url = `getReport1`;
//      }
//     return this.http.get(url);
//  }
     
}
